var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-header" },
    [
      _c("div", { staticClass: "logo-header" }, [
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("@/assets/img/logo.svg") },
        }),
        _c("div", { staticClass: "logo-right" }, [
          _c(
            "span",
            {
              staticClass: "logo-logout logo-right--hover",
              on: {
                click: function ($event) {
                  return _vm.showOut()
                },
              },
            },
            [_vm._v(_vm._s(_vm._("Exit")))]
          ),
        ]),
      ]),
      _c("Out", {
        ref: "Out",
        attrs: { showInputDialog: _vm.showOutDialog },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.showOutDialog = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.showOutDialog = $event
          },
          change: function ($event) {
            return _vm.showOut()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }